import Vue from 'vue'
import './plugins/fontawesome'
import './plugins/myupload'
import './plugins/element.js'
import App from './App.vue'
import router from './router'
import store from './store';
import axios from 'axios';
import VueCookies from 'vue-cookies'

//global variable / environment
// staging
// Vue.prototype.$webURL  = 'https://publicgold.apphub.ga'
// axios.defaults.baseURL = 'https://publicgold.apphub.ga/user/';

//live
Vue.prototype.$webURL  = 'https://publicgold.me/'
axios.defaults.baseURL = 'https://publicgold.me/app/user/';

//local
// Vue.prototype.$webURL  = 'http://localhost'
// axios.defaults.baseURL = 'http://localhost/user/';

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

Vue.use(VueCookies)
Vue.$cookies.config('7d')

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
